import React, { useState, useRef, useEffect } from 'react';
import question_icon from 'src/images/icon/question_icon.png';

interface FormFieldSingleSelectDropdownProps {
    label: string;
    name: string;
    value?: string;
    onChange: (selectedValue: string) => void;
    options: string[];
    className?: string;
    warning?: string;
    infoMessage?: string;
    placeholder?: string;
    error?: boolean;
    errorMessage?: string;
    onBlur?: () => void;
}

const FormFieldSingleSelectDropdown: React.FC<FormFieldSingleSelectDropdownProps> = ({
    label,
    name,
    value = '',
    onChange,
    options,
    className = 'form-field',
    warning,
    infoMessage,
    placeholder = 'Select an option',
    error,
    errorMessage,
    onBlur
}) => {
    const [showInfo, setShowInfo] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
                setIsOpen(false);
                if (onBlur) onBlur();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onBlur]);

    const handleOptionSelect = (option: string) => {
        onChange(option);
        setIsOpen(false);
    };

    const displayText = value || '';

    return (
        <div className={className}>
            <div className="form-label-row">
                <label className="form-label">{label}</label>
                {infoMessage && (
                    <div
                        style={{ position: 'relative', display: 'inline-block' }}
                        onMouseEnter={() => setShowInfo(true)}
                        onMouseLeave={() => setShowInfo(false)}
                    >
                        <img
                            src={question_icon}
                            alt="Info"
                            className="question-icon"
                        />
                        {showInfo && (
                            <div className="info-message tooltip">
                                {infoMessage}
                            </div>
                        )}
                    </div>
                )}
            </div>
            <div className="multi-select-dropdown-container" ref={containerRef}>
                <div className="form-input-wrapper">
                    <input
                        type="text"
                        name={name}
                        value={displayText}
                        placeholder={placeholder}
                        className={`form-input multi-select-input ${error ? 'form-input-error' : ''}`}
                        onClick={() => setIsOpen(!isOpen)}
                        readOnly
                        style={{ cursor: 'pointer', paddingRight: '30px' }}
                    />
                    <span 
                        className="dropdown-arrow"
                        onClick={() => setIsOpen(!isOpen)}
                        style={{
                            position: 'absolute',
                            right: '8px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            fontSize: '12px',
                            color: '#666'
                        }}
                    >
                        ⌄
                    </span>
                </div>
                {isOpen && (
                    <div className="multi-select-dropdown">
                        {options.map(option => (
                            <div
                                key={option}
                                className="multi-select-option"
                                onClick={() => handleOptionSelect(option)}
                                style={{
                                    padding: '8px 12px',
                                    cursor: 'pointer',
                                    backgroundColor: value === option ? '#f0f0f0' : 'white'
                                }}
                            >
                                <span>{option}</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            {warning && <div className="email-warning">{warning}</div>}
            {error && errorMessage && <div className="field-error">{errorMessage}</div>}
        </div>
    );
};

export default FormFieldSingleSelectDropdown;